import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
   let logged = inject(AuthService).isAuthenticated().is_auth;
   if (logged)
      return true;
   else {
      const router = inject(Router);
      router.navigate(['/auth/main']);
      return false;
   }
};
